import React from 'react';
import propTypes from 'prop-types';

const ChevronIcon = ({ color, direction, fill, width, height, customStyles, customClasses }) => {
	let chevronDirection = direction;
	switch (chevronDirection) {
		case 'up':
			chevronDirection = '-90deg';
			break;
		case 'down':
			chevronDirection = '90deg';
			break;
		case 'left':
			chevronDirection = '180deg';
			break;
		default:
			chevronDirection = '0';
			break;
	}

	const svgStyle = { transform: `rotate(${chevronDirection})`, fill, ...customStyles };

	return (
		<svg
			className={`icon-chevron-left ${customClasses}`}
			style={svgStyle}
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M1 13L7 7L0.999999 1' strokeWidth='2' style={{ fill: 'none', stroke: color ? color : 'inherit' }} />
		</svg>
	);
};

ChevronIcon.propTypes = {
	color: propTypes.string,
	direction: propTypes.string,
	fill: propTypes.string,
	height: propTypes.string,
	width: propTypes.string,
	customClasses: propTypes.string,
	customStyles: propTypes.object,
};

ChevronIcon.defaultProps = {
	color: null,
	direction: 'right',
	fill: 'none',
	width: '9',
	height: '14',
	customStyles: {},
	customClasses: '',
};

export default ChevronIcon;
